/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

// Types live in @gosaas/types (base in src/base/swagger.ts, custom in src/custom/swagger.ts).
// Re-exported here so the client file compiles without duplicating definitions.
export type * from "@gosaas/types";

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<D, E = unknown> extends Response {
	data: D;
	error: E;
}

type CancelToken = symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "//localhost:8080";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			(key) => "undefined" !== typeof query[key],
		);
		return keys
			.map((key) =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null && (typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null && (typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter = this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async (response) => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat ? response.clone() : response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then((data) => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch((e) => {
							r.error = e;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) throw data;
			return data;
		});
	};
}

/**
 * @title ineedatest.email API
 * @version 1.0
 * @termsOfService https://ineedatest.email/legal/terms-of-service
 * @baseUrl //localhost:8080
 * @contact ineedatest.email <support@ineedatest.email> (https://ineedatest.email)
 *
 * ineedatest.email API — authenticate public v1 routes with `Authorization: Bearer gsk_live_...`.
 */
export class Api<SecurityDataType> extends HttpClient<SecurityDataType> {
	api = {
		/**
		 * @description Platform-wide totals for the staff dashboard
		 *
		 * @tags admin
		 * @name AdminStatsList
		 * @summary Admin platform stats
		 * @request GET:/api/admin/stats
		 * @secure
		 */
		adminStatsList: (params: RequestParams = {}) =>
			this.request<ConstantsAdminStatsResponse, ConstantsBaseResponse>({
				path: `/api/admin/stats`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Search and paginate teams with member counts and plans
		 *
		 * @tags admin
		 * @name AdminTeamsList
		 * @summary Admin list teams
		 * @request GET:/api/admin/teams
		 * @secure
		 */
		adminTeamsList: (
			query?: {
				/** Search by team name or email */
				query?: string;
				/** Page (1-based) */
				page?: number;
				/** Page size (max 100) */
				page_size?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsAdminTeamListResponse, ConstantsBaseResponse>({
				path: `/api/admin/teams`,
				method: "GET",
				query: query,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Full staff view of one team
		 *
		 * @tags admin
		 * @name AdminTeamsDetail
		 * @summary Admin team detail
		 * @request GET:/api/admin/teams/{id}
		 * @secure
		 */
		adminTeamsDetail: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsAdminTeamDetailResponse, ConstantsBaseResponse>({
				path: `/api/admin/teams/${id}`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Search and paginate user accounts
		 *
		 * @tags admin
		 * @name AdminUsersList
		 * @summary Admin list users
		 * @request GET:/api/admin/users
		 * @secure
		 */
		adminUsersList: (
			query?: {
				/** Search by email or name */
				query?: string;
				/** Page (1-based) */
				page?: number;
				/** Page size (max 100) */
				page_size?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsAdminUserListResponse, ConstantsBaseResponse>({
				path: `/api/admin/users`,
				method: "GET",
				query: query,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Full staff view of one user account
		 *
		 * @tags admin
		 * @name AdminUsersDetail
		 * @summary Admin user detail
		 * @request GET:/api/admin/users/{id}
		 * @secure
		 */
		adminUsersDetail: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsAdminUserDetailResponse, ConstantsBaseResponse>({
				path: `/api/admin/users/${id}`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Issue a short-lived access token for a user (support sessions). No refresh token is issued; staff cannot impersonate other staff. The action is recorded on the target user's audit log.
		 *
		 * @tags admin
		 * @name AdminUsersImpersonateCreate
		 * @summary Admin impersonate user
		 * @request POST:/api/admin/users/{id}/impersonate
		 * @secure
		 */
		adminUsersImpersonateCreate: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsImpersonationResponse, ConstantsBaseResponse>({
				path: `/api/admin/users/${id}/impersonate`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Sign a user out of every device (security response action)
		 *
		 * @tags admin
		 * @name AdminUsersRevokeSessionsCreate
		 * @summary Admin revoke user sessions
		 * @request POST:/api/admin/users/{id}/revoke-sessions
		 * @secure
		 */
		adminUsersRevokeSessionsCreate: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/admin/users/${id}/revoke-sessions`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Grant or remove staff console access for a user
		 *
		 * @tags admin
		 * @name AdminUsersStaffRoleUpdate
		 * @summary Admin set staff role
		 * @request PUT:/api/admin/users/{id}/staff-role
		 * @secure
		 */
		adminUsersStaffRoleUpdate: (
			id: string,
			input: ConstantsSetStaffRoleInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/admin/users/${id}/staff-role`,
				method: "PUT",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Login
		 *
		 * @tags auth
		 * @name AuthLoginCreate
		 * @summary Login
		 * @request POST:/api/auth/login
		 */
		authLoginCreate: (input: ConstantsLoginInput, params: RequestParams = {}) =>
			this.request<ConstantsLoginResponse, ConstantsBaseResponse>({
				path: `/api/auth/login`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Revoke the device session a refresh token belongs to
		 *
		 * @tags security
		 * @name AuthLogoutCreate
		 * @summary Logout
		 * @request POST:/api/auth/logout
		 */
		authLogoutCreate: (
			input: ConstantsTokenInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/logout`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Exchanges the short-lived single-use mfa_token returned by the OAuth callback, together with an OTP or recovery code, for a token pair. Failed attempts are rate limited per account.
		 *
		 * @tags auth
		 * @name AuthMfaValidateCreate
		 * @summary Complete an OAuth sign-in that requires MFA.
		 * @request POST:/api/auth/mfa/validate
		 */
		authMfaValidateCreate: (
			input: ConstantsValidateMfaInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsLoginResponse, ConstantsBaseResponse>({
				path: `/api/auth/mfa/validate`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Password reset
		 *
		 * @tags auth
		 * @name AuthPasswordResetCreate
		 * @summary Password reset
		 * @request POST:/api/auth/password-reset
		 */
		authPasswordResetCreate: (
			input: ConstantsEmailInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/password-reset`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Register a new user with email and password
		 *
		 * @tags auth
		 * @name AuthRegisterCreate
		 * @summary Register a new user
		 * @request POST:/api/auth/register
		 */
		authRegisterCreate: (
			input: ConstantsRegisterInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/register`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Request email verification
		 *
		 * @tags auth
		 * @name AuthRequestEmailVerificationCreate
		 * @summary Request email verification
		 * @request POST:/api/auth/request-email-verification
		 */
		authRequestEmailVerificationCreate: (
			input: ConstantsEmailInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/request-email-verification`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Reset password
		 *
		 * @tags auth
		 * @name AuthResetPasswordCreate
		 * @summary Reset password
		 * @request POST:/api/auth/reset-password/{token}
		 */
		authResetPasswordCreate: (
			token: string,
			input: ConstantsResetPasswordInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/reset-password/${token}`,
				method: "POST",
				body: input,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Verify email
		 *
		 * @tags auth
		 * @name AuthVerifyEmailCreate
		 * @summary Verify email
		 * @request POST:/api/auth/verify-email/{token}
		 */
		authVerifyEmailCreate: (token: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/auth/verify-email/${token}`,
				method: "POST",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns purchasable API query add-on packs when billing.api_pricing is enabled
		 *
		 * @tags billing
		 * @name BillingQueryAddonsList
		 * @summary List API query add-on tiers
		 * @request GET:/api/billing/query-addons
		 * @secure
		 */
		billingQueryAddonsList: (params: RequestParams = {}) =>
			this.request<ConstantsApiQueryAddonsResponse, ConstantsBaseResponse>({
				path: `/api/billing/query-addons`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Add or change the API query add-on on an active subscription
		 *
		 * @tags billing
		 * @name BillingAddonCreate
		 * @summary Set API query add-on
		 * @request POST:/api/billing/{id}/addon
		 * @secure
		 */
		billingAddonCreate: (
			id: string,
			body: ControllersSetApiQueryAddonBody,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/addon`,
				method: "POST",
				body: body,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Remove the API query add-on from an active subscription
		 *
		 * @tags billing
		 * @name BillingAddonDelete
		 * @summary Remove API query add-on
		 * @request DELETE:/api/billing/{id}/addon
		 * @secure
		 */
		billingAddonDelete: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, any>({
				path: `/api/billing/${id}/addon`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new checkout session for a team
		 *
		 * @tags billing
		 * @name BillingCheckoutCreate
		 * @summary Create checkout session
		 * @request POST:/api/billing/{id}/checkout
		 * @secure
		 */
		billingCheckoutCreate: (
			id: string,
			body: ConstantsCreateCheckoutSessionInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/checkout`,
				method: "POST",
				body: body,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get billing details for a team
		 *
		 * @tags billing
		 * @name BillingDetailsList
		 * @summary Get billing details
		 * @request GET:/api/billing/{id}/details
		 * @secure
		 */
		billingDetailsList: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBillingResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/details`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description List the team's Stripe invoices (newest first). Backfills from Stripe on first view.
		 *
		 * @tags billing
		 * @name BillingInvoicesList
		 * @summary Get billing invoices
		 * @request GET:/api/billing/{id}/invoices
		 * @secure
		 */
		billingInvoicesList: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsInvoicesResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/invoices`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a Stripe Customer Portal session for managing subscription and payment methods
		 *
		 * @tags billing
		 * @name BillingPortalCreate
		 * @summary Create billing portal session
		 * @request POST:/api/billing/{id}/portal
		 * @secure
		 */
		billingPortalCreate: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/portal`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Pulls the team's Stripe subscription into the local billing row (used after checkout redirect).
		 *
		 * @tags billing
		 * @name BillingSyncStripeCreate
		 * @summary Sync billing from Stripe
		 * @request POST:/api/billing/{id}/sync-stripe
		 * @secure
		 */
		billingSyncStripeCreate: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/sync-stripe`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get billing usage for a team. Defaults to current billing period, can query previous or a custom range.
		 *
		 * @tags billing
		 * @name BillingUsageList
		 * @summary Get billing usage
		 * @request GET:/api/billing/{id}/usage
		 * @secure
		 */
		billingUsageList: (
			id: string,
			query?: {
				/** Range selector: current|previous|custom */
				range?: "current" | "previous" | "custom";
				/** Custom range start (RFC3339 or YYYY-MM-DD) */
				start?: string;
				/** Custom range end (RFC3339 or YYYY-MM-DD) */
				end?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsBillingUsageResponse, ConstantsBaseResponse>({
				path: `/api/billing/${id}/usage`,
				method: "GET",
				query: query,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new feedback entry
		 *
		 * @tags feedback
		 * @name FeedbackCreate
		 * @summary Create feedback
		 * @request POST:/api/feedback
		 * @secure
		 */
		feedbackCreate: (
			body: ConstantsCreateFeedbackInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsMessageResponse, ConstantsBaseResponse>({
				path: `/api/feedback`,
				method: "POST",
				body: body,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Processes incoming Stripe webhook events to sync subscription data
		 *
		 * @tags inbound
		 * @name InboundStripeCreate
		 * @summary Handle Stripe webhook events
		 * @request POST:/api/inbound/stripe
		 */
		inboundStripeCreate: (params: RequestParams = {}) =>
			this.request<Record<string, any>, Record<string, any>>({
				path: `/api/inbound/stripe`,
				method: "POST",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Store URLs and OAuth entry paths for native clients (requires mobile_app module)
		 *
		 * @tags mobile-app
		 * @name MobileAppDistributionList
		 * @summary Mobile app distribution metadata
		 * @request GET:/api/mobile-app/distribution
		 */
		mobileAppDistributionList: (params: RequestParams = {}) =>
			this.request<ControllersMobileAppDistributionResponse, any>({
				path: `/api/mobile-app/distribution`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve GitHub Auth URL
		 *
		 * @tags oauth
		 * @name OauthGithubList
		 * @summary Retrieve GitHub Auth URL
		 * @request GET:/api/oauth/github
		 */
		oauthGithubList: (params: RequestParams = {}) =>
			this.request<ConstantsOAuthResponse, ConstantsBaseResponse>({
				path: `/api/oauth/github`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description GitHub Callback
		 *
		 * @tags oauth
		 * @name OauthGithubCallbackCreate
		 * @summary GitHub Callback
		 * @request POST:/api/oauth/github/callback
		 */
		oauthGithubCallbackCreate: (
			query: {
				/** Code */
				code: string;
				/** State */
				state: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsLoginResponse, ConstantsBaseResponse>({
				path: `/api/oauth/github/callback`,
				method: "POST",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve GitHub OAuth URL configured for mobile deep link redirect
		 *
		 * @tags oauth
		 * @name OauthGithubMobileList
		 * @summary Retrieve GitHub Mobile Auth URL
		 * @request GET:/api/oauth/github/mobile
		 */
		oauthGithubMobileList: (params: RequestParams = {}) =>
			this.request<ConstantsOAuthResponse, ConstantsBaseResponse>({
				path: `/api/oauth/github/mobile`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Exchange GitHub OAuth code for app tokens using mobile redirect URI
		 *
		 * @tags oauth
		 * @name OauthGithubMobileCallbackCreate
		 * @summary GitHub Mobile Callback
		 * @request POST:/api/oauth/github/mobile/callback
		 */
		oauthGithubMobileCallbackCreate: (
			query: {
				/** Code */
				code: string;
				/** State */
				state: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsLoginResponse, ConstantsBaseResponse>({
				path: `/api/oauth/github/mobile/callback`,
				method: "POST",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve Google Auth URL
		 *
		 * @tags oauth
		 * @name OauthGoogleList
		 * @summary Retrieve Google Auth URL
		 * @request GET:/api/oauth/google
		 */
		oauthGoogleList: (params: RequestParams = {}) =>
			this.request<ConstantsOAuthResponse, ConstantsBaseResponse>({
				path: `/api/oauth/google`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Google Callback
		 *
		 * @tags oauth
		 * @name OauthGoogleCallbackCreate
		 * @summary Google Callback
		 * @request POST:/api/oauth/google/callback
		 */
		oauthGoogleCallbackCreate: (
			query: {
				/** Code */
				code: string;
				/** State */
				state: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/oauth/google/callback`,
				method: "POST",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve Google OAuth URL configured for mobile deep link redirect
		 *
		 * @tags oauth
		 * @name OauthGoogleMobileList
		 * @summary Retrieve Google Mobile Auth URL
		 * @request GET:/api/oauth/google/mobile
		 */
		oauthGoogleMobileList: (params: RequestParams = {}) =>
			this.request<ConstantsOAuthResponse, ConstantsBaseResponse>({
				path: `/api/oauth/google/mobile`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Exchange Google OAuth code for app tokens using mobile redirect URI
		 *
		 * @tags oauth
		 * @name OauthGoogleMobileCallbackCreate
		 * @summary Google Mobile Callback
		 * @request POST:/api/oauth/google/mobile/callback
		 */
		oauthGoogleMobileCallbackCreate: (
			query: {
				/** Code */
				code: string;
				/** State */
				state: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsLoginResponse, ConstantsBaseResponse>({
				path: `/api/oauth/google/mobile/callback`,
				method: "POST",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new public feedback entry (no authentication required)
		 *
		 * @tags feedback
		 * @name PublicFeedbackCreate
		 * @summary Create public feedback
		 * @request POST:/api/public-feedback
		 */
		publicFeedbackCreate: (
			body: ConstantsCreatePublicFeedbackInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsMessageResponse, ConstantsBaseResponse>({
				path: `/api/public-feedback`,
				method: "POST",
				body: body,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Revoke all refresh sessions for the authenticated user. Existing access tokens expire naturally (within 15 minutes).
		 *
		 * @tags security
		 * @name SecurityLogoutCreate
		 * @summary Logout
		 * @request POST:/api/security/logout
		 * @secure
		 */
		securityLogoutCreate: (params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/security/logout`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Retrieve access token
		 *
		 * @tags security
		 * @name SecurityRetrieveAccessTokenCreate
		 * @summary Retrieve access token
		 * @request POST:/api/security/retrieve-access-token
		 */
		securityRetrieveAccessTokenCreate: (
			input: ConstantsTokenInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsRetrieveAccessTokenResponse, ConstantsBaseResponse>(
				{
					path: `/api/security/retrieve-access-token`,
					method: "POST",
					body: input,
					type: ContentType.Json,
					format: "json",
					...params,
				},
			),

		/**
		 * @description List the caller's active device sessions (refresh token families)
		 *
		 * @tags security
		 * @name SecuritySessionsList
		 * @summary List active sessions
		 * @request GET:/api/security/sessions
		 * @secure
		 */
		securitySessionsList: (params: RequestParams = {}) =>
			this.request<ConstantsSessionsResponse, ConstantsBaseResponse>({
				path: `/api/security/sessions`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Revoke every device session except the caller's current one
		 *
		 * @tags security
		 * @name SecuritySessionsRevokeAllCreate
		 * @summary Sign out everywhere else
		 * @request POST:/api/security/sessions/revoke-all
		 * @secure
		 */
		securitySessionsRevokeAllCreate: (params: RequestParams = {}) =>
			this.request<ConstantsRevokedSessionsResponse, ConstantsBaseResponse>({
				path: `/api/security/sessions/revoke-all`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Sign out one device session by its session id
		 *
		 * @tags security
		 * @name SecuritySessionsDelete
		 * @summary Revoke a session
		 * @request DELETE:/api/security/sessions/{sessionId}
		 * @secure
		 */
		securitySessionsDelete: (sessionId: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/security/sessions/${sessionId}`,
				method: "DELETE",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get team audit logs
		 *
		 * @tags security
		 * @name SecurityTeamAuditLogsTeamIdList
		 * @summary Get team audit logs
		 * @request GET:/api/security/team-audit-logs/:teamId
		 * @secure
		 */
		securityTeamAuditLogsTeamIdList: (
			teamId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsAuditLogsResponse, ConstantsBaseResponse>({
				path: `/api/security/team-audit-logs/${teamId}`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get user audit logs
		 *
		 * @tags security
		 * @name SecurityUserAuditLogsList
		 * @summary Get user audit logs
		 * @request GET:/api/security/user-audit-logs
		 * @secure
		 */
		securityUserAuditLogsList: (params: RequestParams = {}) =>
			this.request<ConstantsAuditLogsResponse, ConstantsBaseResponse>({
				path: `/api/security/user-audit-logs`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags misc
		 * @name SeoOgImageList
		 * @summary OG image generator
		 * @request GET:/api/seo/og-image
		 */
		seoOgImageList: (
			query?: {
				/** Page title */
				title?: string;
				/** Page description */
				description?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<Blob, any>({
				path: `/api/seo/og-image`,
				method: "GET",
				query: query,
				format: "blob",
				...params,
			}),

		/**
		 * @description Create a new team
		 *
		 * @tags team
		 * @name TeamCreate
		 * @summary Create a new team
		 * @request POST:/api/team
		 * @secure
		 */
		teamCreate: (team: ConstantsCreateTeamInput, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team`,
				method: "POST",
				body: team,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update a team
		 *
		 * @tags team
		 * @name TeamUpdate
		 * @summary Update a team
		 * @request PUT:/api/team/{id}
		 * @secure
		 */
		teamUpdate: (
			id: string,
			team: ConstantsUpdateTeamInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}`,
				method: "PUT",
				body: team,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags api-keys
		 * @name TeamApiAccessList
		 * @summary Check API access entitlement
		 * @request GET:/api/team/{id}/api-access
		 * @secure
		 */
		teamApiAccessList: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsApiAccessResponse, any>({
				path: `/api/team/${id}/api-access`,
				method: "GET",
				secure: true,
				...params,
			}),

		/**
		 * @description List API keys for a team
		 *
		 * @tags api-keys
		 * @name TeamApiKeysList
		 * @summary List API keys
		 * @request GET:/api/team/{id}/api-keys
		 * @secure
		 */
		teamApiKeysList: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsListApiKeysResponse, any>({
				path: `/api/team/${id}/api-keys`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Create a new API key for a team
		 *
		 * @tags api-keys
		 * @name TeamApiKeysCreate
		 * @summary Create API key
		 * @request POST:/api/team/{id}/api-keys
		 * @secure
		 */
		teamApiKeysCreate: (
			id: string,
			input: ConstantsCreateApiKeyInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsCreateApiKeyResponse, any>({
				path: `/api/team/${id}/api-keys`,
				method: "POST",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Revoke an API key
		 *
		 * @tags api-keys
		 * @name TeamApiKeysDelete
		 * @summary Revoke API key
		 * @request DELETE:/api/team/{id}/api-keys/{keyId}
		 * @secure
		 */
		teamApiKeysDelete: (
			id: string,
			keyId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsMessageResponse, any>({
				path: `/api/team/${id}/api-keys/${keyId}`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Update API key name and/or scopes
		 *
		 * @tags api-keys
		 * @name TeamApiKeysPartialUpdate
		 * @summary Update API key
		 * @request PATCH:/api/team/{id}/api-keys/{keyId}
		 * @secure
		 */
		teamApiKeysPartialUpdate: (
			id: string,
			keyId: string,
			input: ConstantsUpdateApiKeyInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsUpdateApiKeyResponse, any>({
				path: `/api/team/${id}/api-keys/${keyId}`,
				method: "PATCH",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Generate a new secret for an existing API key. The previous secret stops working immediately.
		 *
		 * @tags api-keys
		 * @name TeamApiKeysRollCreate
		 * @summary Roll API key
		 * @request POST:/api/team/{id}/api-keys/{keyId}/roll
		 * @secure
		 */
		teamApiKeysRollCreate: (
			id: string,
			keyId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsRollApiKeyResponse, any>({
				path: `/api/team/${id}/api-keys/${keyId}/roll`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Update role of a team member
		 *
		 * @tags team
		 * @name TeamMemberUpdate
		 * @summary Update team member
		 * @request PUT:/api/team/{id}/member
		 * @secure
		 */
		teamMemberUpdate: (
			id: string,
			input: ConstantsUpdateTeamMemberInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/member`,
				method: "PUT",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Remove a member from the team
		 *
		 * @tags team
		 * @name TeamMemberDelete
		 * @summary Remove team member
		 * @request DELETE:/api/team/{id}/member
		 * @secure
		 */
		teamMemberDelete: (
			id: string,
			input: ConstantsIdInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/member`,
				method: "DELETE",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get list of team members
		 *
		 * @tags team
		 * @name TeamMembersList
		 * @summary Get team members
		 * @request GET:/api/team/{id}/members
		 * @secure
		 */
		teamMembersList: (id: string, params: RequestParams = {}) =>
			this.request<
				ConstantsListPublicTeamMembersResponse,
				ConstantsBaseResponse
			>({
				path: `/api/team/${id}/members`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Invite a team member
		 *
		 * @tags team
		 * @name TeamMembersInviteCreate
		 * @summary Invite a team member
		 * @request POST:/api/team/{id}/members/invite
		 * @secure
		 */
		teamMembersInviteCreate: (
			id: string,
			team: ConstantsInviteTeamMemberInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/members/invite`,
				method: "POST",
				body: team,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Cancel a team invite
		 *
		 * @tags team
		 * @name TeamMembersInviteDelete
		 * @summary Cancel team invite
		 * @request DELETE:/api/team/{id}/members/invite
		 * @secure
		 */
		teamMembersInviteDelete: (
			id: string,
			input: ConstantsIdInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/members/invite`,
				method: "DELETE",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get list of pending team invites
		 *
		 * @tags team
		 * @name TeamMembersInvitesList
		 * @summary Get pending team invites
		 * @request GET:/api/team/{id}/members/invites
		 * @secure
		 */
		teamMembersInvitesList: (id: string, params: RequestParams = {}) =>
			this.request<
				ConstantsListPublicTeamInvitesResponse,
				ConstantsBaseResponse
			>({
				path: `/api/team/${id}/members/invites`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns all external notification channels for the specified team
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsList
		 * @summary List notification channels
		 * @request GET:/api/team/{id}/notifications/channels
		 * @secure
		 */
		teamNotificationsChannelsList: (id: string, params: RequestParams = {}) =>
			this.request<
				ConstantsGetNotificationChannelsResponse,
				ConstantsBaseResponse
			>({
				path: `/api/team/${id}/notifications/channels`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Creates a new external notification channel for the specified team
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsCreate
		 * @summary Create notification channel
		 * @request POST:/api/team/{id}/notifications/channels
		 * @secure
		 */
		teamNotificationsChannelsCreate: (
			id: string,
			channel: ConstantsCreateNotificationChannelInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/channels`,
				method: "POST",
				body: channel,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Updates an existing notification channel
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsUpdate
		 * @summary Update notification channel
		 * @request PUT:/api/team/{id}/notifications/channels/{channelId}
		 * @secure
		 */
		teamNotificationsChannelsUpdate: (
			id: string,
			channelId: string,
			channel: ConstantsUpdateNotificationChannelInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/channels/${channelId}`,
				method: "PUT",
				body: channel,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Deletes a notification channel and removes it from any rules
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsDelete
		 * @summary Delete notification channel
		 * @request DELETE:/api/team/{id}/notifications/channels/{channelId}
		 * @secure
		 */
		teamNotificationsChannelsDelete: (
			id: string,
			channelId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/channels/${channelId}`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Sends a test webhook to verify the endpoint is reachable. Marks the channel as verified on success.
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsTestCreate
		 * @summary Test webhook notification channel
		 * @request POST:/api/team/{id}/notifications/channels/{channelId}/test
		 * @secure
		 */
		teamNotificationsChannelsTestCreate: (
			id: string,
			channelId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/channels/${channelId}/test`,
				method: "POST",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Verifies an email notification channel via a token sent to the email address
		 *
		 * @tags notifications
		 * @name TeamNotificationsChannelsVerifyList
		 * @summary Verify email notification channel
		 * @request GET:/api/team/{id}/notifications/channels/{channelId}/verify
		 */
		teamNotificationsChannelsVerifyList: (
			id: string,
			channelId: string,
			query: {
				/** Verification token */
				token: string;
			},
			params: RequestParams = {},
		) =>
			this.request<any, string | ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/channels/${channelId}/verify`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * @description Returns the list of all predefined event types that can trigger notification rules
		 *
		 * @tags notifications
		 * @name TeamNotificationsEventsList
		 * @summary List notification events
		 * @request GET:/api/team/{id}/notifications/events
		 * @secure
		 */
		teamNotificationsEventsList: (id: string, params: RequestParams = {}) =>
			this.request<
				ConstantsGetNotificationEventsResponse,
				ConstantsBaseResponse
			>({
				path: `/api/team/${id}/notifications/events`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns all notification rules for the specified team, including channel targets
		 *
		 * @tags notifications
		 * @name TeamNotificationsRulesList
		 * @summary List notification rules
		 * @request GET:/api/team/{id}/notifications/rules
		 * @secure
		 */
		teamNotificationsRulesList: (id: string, params: RequestParams = {}) =>
			this.request<
				ConstantsGetNotificationRulesResponse,
				ConstantsBaseResponse
			>({
				path: `/api/team/${id}/notifications/rules`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Creates a new notification rule that maps an event to one or more channels
		 *
		 * @tags notifications
		 * @name TeamNotificationsRulesCreate
		 * @summary Create notification rule
		 * @request POST:/api/team/{id}/notifications/rules
		 * @secure
		 */
		teamNotificationsRulesCreate: (
			id: string,
			rule: ConstantsCreateNotificationRuleInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/rules`,
				method: "POST",
				body: rule,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Updates a notification rule and replaces its channel assignments
		 *
		 * @tags notifications
		 * @name TeamNotificationsRulesUpdate
		 * @summary Update notification rule
		 * @request PUT:/api/team/{id}/notifications/rules/{ruleId}
		 * @secure
		 */
		teamNotificationsRulesUpdate: (
			id: string,
			ruleId: string,
			rule: ConstantsUpdateNotificationRuleInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/rules/${ruleId}`,
				method: "PUT",
				body: rule,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Deletes a notification rule and all its channel assignments
		 *
		 * @tags notifications
		 * @name TeamNotificationsRulesDelete
		 * @summary Delete notification rule
		 * @request DELETE:/api/team/{id}/notifications/rules/{ruleId}
		 * @secure
		 */
		teamNotificationsRulesDelete: (
			id: string,
			ruleId: string,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/notifications/rules/${ruleId}`,
				method: "DELETE",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Get team settings
		 *
		 * @tags team
		 * @name TeamSettingsList
		 * @summary Get team settings
		 * @request GET:/api/team/{id}/settings
		 * @secure
		 */
		teamSettingsList: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsGetTeamSettingsResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/settings`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update team settings
		 *
		 * @tags team
		 * @name TeamSettingsUpdate
		 * @summary Update team settings
		 * @request PUT:/api/team/{id}/settings
		 * @secure
		 */
		teamSettingsUpdate: (
			id: string,
			body: ConstantsUpdateTeamSettingsInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/team/${id}/settings`,
				method: "PUT",
				body: body,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get user
		 *
		 * @tags user
		 * @name UserList
		 * @summary Get user
		 * @request GET:/api/user
		 * @secure
		 */
		userList: (params: RequestParams = {}) =>
			this.request<ConstantsGetUserResponse, ConstantsBaseResponse>({
				path: `/api/user`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update user
		 *
		 * @tags user
		 * @name UserUpdate
		 * @summary Update user
		 * @request PUT:/api/user
		 * @secure
		 */
		userUpdate: (input: ConstantsUpdateUserInput, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user`,
				method: "PUT",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Permanently delete the account after verifying the emailed code (and MFA when enabled). Irreversible.
		 *
		 * @tags user
		 * @name UserDelete
		 * @summary Delete account
		 * @request DELETE:/api/user
		 * @secure
		 */
		userDelete: (
			input: ConstantsDeleteAccountInput,
			params: RequestParams = {},
		) =>
			this.request<
				ConstantsBaseResponse,
				ConstantsBaseResponse | ConstantsAccountDeletionBlockedResponse
			>({
				path: `/api/user`,
				method: "DELETE",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Emails a verification code that confirms a pending account deletion. Fails when teams block deletion.
		 *
		 * @tags user
		 * @name UserDeleteRequestCreate
		 * @summary Request account deletion
		 * @request POST:/api/user/delete/request
		 * @secure
		 */
		userDeleteRequestCreate: (params: RequestParams = {}) =>
			this.request<
				ConstantsBaseResponse,
				ConstantsBaseResponse | ConstantsAccountDeletionBlockedResponse
			>({
				path: `/api/user/delete/request`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update user email
		 *
		 * @tags user
		 * @name UserEmailUpdate
		 * @summary Update user email
		 * @request PUT:/api/user/email
		 * @secure
		 */
		userEmailUpdate: (
			input: ConstantsUpdateUserEmailInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/email`,
				method: "PUT",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Verify email change
		 *
		 * @tags user
		 * @name UserEmailVerifyCreate
		 * @summary Verify email change
		 * @request POST:/api/user/email/verify/{token}
		 * @secure
		 */
		userEmailVerifyCreate: (token: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/email/verify/${token}`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Download a machine-readable export of all personal data (GDPR data portability)
		 *
		 * @tags user
		 * @name UserExportList
		 * @summary Export account data
		 * @request GET:/api/user/export
		 * @secure
		 */
		userExportList: (params: RequestParams = {}) =>
			this.request<ConstantsAccountExportResponse, ConstantsBaseResponse>({
				path: `/api/user/export`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Disable MFA for the authenticated user
		 *
		 * @tags user
		 * @name UserMfaDisableCreate
		 * @summary Disable MFA
		 * @request POST:/api/user/mfa/disable
		 * @secure
		 */
		userMfaDisableCreate: (
			token: ConstantsTokenInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/mfa/disable`,
				method: "POST",
				body: token,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Initiates MFA setup by generating a new TOTP secret and QR code URL
		 *
		 * @tags user
		 * @name UserMfaSetupCreate
		 * @summary Setup MFA
		 * @request POST:/api/user/mfa/setup
		 * @secure
		 */
		userMfaSetupCreate: (params: RequestParams = {}) =>
			this.request<ConstantsMfaSetupResponse, ConstantsBaseResponse>({
				path: `/api/user/mfa/setup`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Verify MFA setup by validating the provided token
		 *
		 * @tags user
		 * @name UserMfaSetupVerifyCreate
		 * @summary Verify MFA setup
		 * @request POST:/api/user/mfa/setup/verify
		 * @secure
		 */
		userMfaSetupVerifyCreate: (
			token: ConstantsTokenInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsMfaVerifyResponse, ConstantsBaseResponse>({
				path: `/api/user/mfa/setup/verify`,
				method: "POST",
				body: token,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Paginated in-app notifications for the caller, newest first, with unread count
		 *
		 * @tags inbox
		 * @name UserNotificationsList
		 * @summary List inbox notifications
		 * @request GET:/api/user/notifications
		 * @secure
		 */
		userNotificationsList: (
			query?: {
				/** Only unread notifications */
				unread_only?: boolean;
				/** Page (1-based) */
				page?: number;
				/** Page size (max 100) */
				page_size?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsInboxListResponse, ConstantsBaseResponse>({
				path: `/api/user/notifications`,
				method: "GET",
				query: query,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Mark every unread in-app notification as read
		 *
		 * @tags inbox
		 * @name UserNotificationsReadAllCreate
		 * @summary Mark all notifications read
		 * @request POST:/api/user/notifications/read-all
		 * @secure
		 */
		userNotificationsReadAllCreate: (params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/notifications/read-all`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Delete one in-app notification
		 *
		 * @tags inbox
		 * @name UserNotificationsDelete
		 * @summary Delete notification
		 * @request DELETE:/api/user/notifications/{id}
		 * @secure
		 */
		userNotificationsDelete: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/notifications/${id}`,
				method: "DELETE",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Mark one in-app notification as read
		 *
		 * @tags inbox
		 * @name UserNotificationsReadCreate
		 * @summary Mark notification read
		 * @request POST:/api/user/notifications/{id}/read
		 * @secure
		 */
		userNotificationsReadCreate: (id: string, params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/notifications/${id}/read`,
				method: "POST",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Update user password
		 *
		 * @tags user
		 * @name UserPasswordUpdate
		 * @summary Update user password
		 * @request PUT:/api/user/password
		 * @secure
		 */
		userPasswordUpdate: (
			input: ConstantsUpdatePasswordInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/password`,
				method: "PUT",
				body: input,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get teams for the authenticated user
		 *
		 * @tags user
		 * @name UserTeamsList
		 * @summary Get teams
		 * @request GET:/api/user/teams
		 * @secure
		 */
		userTeamsList: (params: RequestParams = {}) =>
			this.request<ConstantsGetTeamResponse, ConstantsBaseResponse>({
				path: `/api/user/teams`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Accept a team invite
		 *
		 * @tags user
		 * @name UserTeamsInviteCreate
		 * @summary Accept team invite
		 * @request POST:/api/user/teams/invite
		 * @secure
		 */
		userTeamsInviteCreate: (
			token: ConstantsIdInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/teams/invite`,
				method: "POST",
				body: token,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Decline a team invite
		 *
		 * @tags user
		 * @name UserTeamsInviteDelete
		 * @summary Decline team invite
		 * @request DELETE:/api/user/teams/invite
		 * @secure
		 */
		userTeamsInviteDelete: (
			token: ConstantsIdInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/teams/invite`,
				method: "DELETE",
				body: token,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Get team invites for the authenticated user
		 *
		 * @tags user
		 * @name UserTeamsInvitesList
		 * @summary Get team invites
		 * @request GET:/api/user/teams/invites
		 * @secure
		 */
		userTeamsInvitesList: (params: RequestParams = {}) =>
			this.request<ConstantsTeamUserInvitesResponse, ConstantsBaseResponse>({
				path: `/api/user/teams/invites`,
				method: "GET",
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Leave a team
		 *
		 * @tags user
		 * @name UserTeamsLeaveCreate
		 * @summary Leave team
		 * @request POST:/api/user/teams/leave
		 * @secure
		 */
		userTeamsLeaveCreate: (
			token: ConstantsIdInput,
			params: RequestParams = {},
		) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/api/user/teams/leave`,
				method: "POST",
				body: token,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	health = {
		/**
		 * @description Check if the server is running
		 *
		 * @tags health
		 * @name HealthList
		 * @summary Healthcheck
		 * @request GET:/health
		 */
		healthList: (params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/health`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	ping = {
		/**
		 * @description Check if the server is running
		 *
		 * @tags health
		 * @name PingList
		 * @summary Heartbeat
		 * @request GET:/ping
		 */
		pingList: (params: RequestParams = {}) =>
			this.request<ConstantsBaseResponse, ConstantsBaseResponse>({
				path: `/ping`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
}
